export default __webpack_public_path__ + "static/media/Splenic_Flexure_Set_Up_Male_.5e44dc36.png";